import { PropsWithChildren, useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import { ShowToast, ToastCtx, VisibleToast } from "./ToastCtx.ts";

const TOAST_DURATION_MS = 2500;

export function ToastProvider({ children }: PropsWithChildren) {
  const [visibleToast, setVisibleToast] = useState<VisibleToast | null>(null);

  const showToast = useCallback<ShowToast>((message, tone = "success") => {
    setVisibleToast({ message, tone, shownAt: Date.now() });
  }, []);

  useEffect(() => {
    if (!visibleToast) return;
    const hideTimeout = setTimeout(
      () => setVisibleToast(null),
      TOAST_DURATION_MS,
    );
    return () => clearTimeout(hideTimeout);
  }, [visibleToast]);

  return (
    <ToastCtx.Provider value={showToast}>
      {children}
      {visibleToast &&
        createPortal(
          <div
            role={"status"}
            className={
              "fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-2 rounded-lg bg-slate-800 px-4 py-2 text-sm text-white shadow-lg"
            }
          >
            {visibleToast.tone === "error" ? (
              <ExclamationCircleIcon className={"h-5 w-5 text-red-400"} />
            ) : (
              <CheckCircleIcon className={"h-5 w-5 text-green-400"} />
            )}
            {visibleToast.message}
          </div>,
          document.body,
        )}
    </ToastCtx.Provider>
  );
}
